export function articleJsonToHtml(content) {
  if (!content) {
    return '';
  }

  if (typeof content === 'string') {
    const trimmed = content.trim();
    if (trimmed.startsWith('<')) {
      return content;
    }

    try {
      return articleJsonToHtml(JSON.parse(content));
    } catch (error) {
      return content;
    }
  }

  const articleContent = content.articleContent || [];
  if (!articleContent.length) {
    return '';
  }

  if (articleContent.length === 1 && /<[^>]+>/.test(articleContent[0].text || '')) {
    return articleContent[0].text;
  }

  const links = content.articleLinks || [];
  const images = content.articleImages || [];

  return articleContent.map((block) => {
    let text = block.text || '';

    links.forEach((link) => {
      if (link.id && text.includes(link.id)) {
        const label = link.text || link.link || '';
        text = text.split(link.id).join(`<a href="${link.link}">${label}</a>`);
      }
    });

    images.forEach((image) => {
      if (image.id && text.includes(image.id)) {
        text = text.split(image.id).join(`<img src="${image.link}" alt="" />`);
      }
    });

    const type = block.type || 'p';
    if (type === 'li') {
      return `<li>${text}</li>`;
    }

    return `<${type}>${text}</${type}>`;
  }).join('');
}
